module.exports = __webpack_public_path__ + "img/female-newborn-hand.2ba9e9be.svg";